import { css } from '@emotion/react'
import { NextPage, NextPageContext } from 'next'
import { Notice } from '../../types'
import { fetchNotice } from '@/lib/notice'
import { BodyMarkdown } from '@/components/pages/information/Markdown'
import { Heading } from '@/components/pages/information/Heading'
import Error from '../_error'
import { NoticeHead } from '@/components/common/Head'
import { EnterpriseTemplate } from '@/components/pages/enterprise/templates/EnterpriseTemplate'
import { mq } from 'plume-ui'

type Props = {
  notice: Notice | undefined
}

const NoticePage: NextPage<Props> = (props) => {
  if (!props.notice || !props.notice.body) {
    return <Error />
  }

  return (
    <EnterpriseTemplate>
      <NoticeHead notice={props.notice} />
      <Heading
        title={props.notice.title}
        publishedAt={props.notice.publishedAt}
        headerImage={props.notice.headerImage}
      />
      <div
        css={css`
          margin: -107px 24px 32px;
          ${mq.large} {
            margin: -300px auto 48px;
            max-width: 816px;
          }
        `}
      >
        <img
          src={props.notice.headerImage.url}
          alt={props.notice.headerImage.title}
          css={css`
            display: block;
            border-radius: 4px;
          `}
        />
      </div>
      <ContentWrapper>
        <BodyMarkdown shrink>{props.notice.body}</BodyMarkdown>
      </ContentWrapper>
    </EnterpriseTemplate>
  )
}

type ContentWrapperProps = {
  children: React.ReactNode
}

const ContentWrapper: React.FC<ContentWrapperProps> = (props) => {
  return (
    <div
      css={css`
        margin: 0 auto;
        ${mq.large} {
          max-width: 736px;
        }
      `}
      {...props}
    />
  )
}

NoticePage.getInitialProps = async ({ query }: NextPageContext) => {
  const { slugOrId } = query
  const notice = await fetchNotice(slugOrId as string)
  return { notice }
}

export default NoticePage
